export const ServiceData = [
  {
    id: 1,
    title: "machine",
    handle: "/service/machine",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Service_1_Machine_shop.jpg",
    youtube: "",
    content: `# Металл Хийц Боловсруулах Төв (MSH)

2019 оны 10-р сарын 9-нд нээлтээ хийснээс хойш манай **Механик боловсруулалтын цех (MSH)** нь нийт **4,500 гаруй дэд эд ангиудыг сэргээн засварласан** бөгөөд энэ нь **Агрегат засварын төв (АЗТ)** болон **Их засварын цехийн** үйл ажиллагаанд томоохон дэмжлэг үзүүлэхээс гадна **харилцагч байгууллагуудын тоног төхөөрөмжийн эд ангиудыг сэргээн засварлах** чухал боломжийг бий болгосон байна.

Металл Хийц Боловсруулах Төв нь дэд эд ангиудыг үйлдвэрт хийгдсэн засвартай дүйцэхүйц түвшинд сэргээн үйлдвэрлэх чадвартай. Энэхүү ажиллагаагаа:

- Өөрсдийн дотоод нөөцөөр гүйцэтгэдэг бөгөөд  
- Caterpillar-ийн *Reuse and Salvage* зааварчилгааг чанд мөрддөг.  

Үүний үр дүнд бид харьцангуй **хямд өртөгтэй**, **өндөр чанартай**, **богино хугацаанд гүйцэтгэгдэх шийдлүүдийг** санал болгох боломжтой болсон.

Манай чадварлаг, мэргэжлийн сертификажсан техникчид дараах дэвшилтэт тоног төхөөрөмж, технологиудыг ашиглан ажилладаг. Үүнд:

- CNC технологид суурилсан өндөр нарийвчлалтай босоо токарийн суурь машин**  
- Гадаргуу зорох, өнгөлөх машин  
- Радиаль өрөмдлөгийн машин  
- Хэвтээ фрезерийн суурь машин  
- Тахир гол өнгөлөх машин  
- Элсээр буудах камер  
- Fanuc брэндийн роботыг ашиглан автомат цахилгаан нуман гагнуур хийх систем

Мөн:

- Хэт авианы шалгалт  
- Наалдац ба холбоосын бат бэхийн туршилт зэрэг үл эвдэх сорил шалгалтын төхөөрөмжүүдтэй.

Дээрх дэвшилтэт тоног төхөөрөмж, өндөр ур чадвартай инженерүүдийн ачаар бидний сэргээн засварлах боломж нь зөвхөн **CAT брэндийн тоног төхөөрөмжөөр хязгаарлагдахгүй**. Бид харилцагчдаасаа хүлээн авсан техникийн мэдээлэлд үндэслэн **Cummins**, **MTU**, **Hitachi**, **Hyundai**, **Liebherr** зэрэг төрөл бүрийн үйлдвэрийн тоног төхөөрөмжийн эд ангийг сэргээн засварлах бүрэн чадамжтай.

Манай Металл хийц боловсруулах төв нь бүх төрлийн тоног төхөөрөмжийн брэндүүдийн эд ангиудыг тухайн харилцагчийн **техникийн баримт бичиг болон үзүүлэлтүүдийн дагуу** засварлаж, **найдвартай ажиллагаа**, **эд ангийн урт хугацааны ашиглалтын баталгааг** хангаж дараах үйлчилгээний зорилготойгоор ажиллаж байна:

- Харилцагчиддаа илүү хурдан хугацаанд  
- Илүү боломжийн үнээр  
- Чанарын өндөр түвшинд сэргээгдсэн эд анги нийлүүлэхэд оршдог.
`,
    content_en: `# Machine Shop (MSH)

Since its inauguration on **October 9, 2019**, the **Machine Shop (MSH)** has successfully salvaged over **4,500 subcomponents**, supporting customers, the CRC, and both workshop and field service operations.

### Capabilities

With the ability to remanufacture subcomponents to **factory standards**, the MSH:
- Operates using in-house resources  
- Adheres strictly to **Caterpillar's Reuse and Salvage Guidelines**  

This approach offers:
- Cost-effective, high-quality solutions  
- Reduced lead times  
- Measurable savings  
- Increased equipment uptime

### Equipment and Technologies

Our certified technicians use:
- Vertical Lathe  
- Horizontal Boring Machine  
- Milling Machine  
- Crankshaft Polisher  
- Radial Drill  
- Multi-Purpose Boring  
- Surfacing & Line Boring Machines  
- Horizontal Lathe  
- Machining Center  
- Grit Blasting Booth  

**Non-Destructive Testing (NDT):**
- Ultrasonic Inspection  
- Adhesion and Cohesion Strength Testing of Arc-Sprayed Coatings  

**Robotic Arc Spray Metallization System** enables:
- Uniform, precise coatings  
- Minimal material use  
- Reduced processing time  

This technology complies with **Standard Test Methods for Adhesion or Cohesion Strength of Thermal Spray Coatings**, ensuring international quality and safety standards.

### Services

Our Machine Shop provides:
- Fast, reliable, and consistent results across various components and industries  
- Repair and restoration services for components from all major equipment brands  
- Full compliance with customer-provided technical documentation and specifications  

**Date:** April 10, 2025`,
  },
  {
    id: 2,
    title: "main",
    handle: "/service/main",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Service_2_Mainshop.jpg",
    youtube: "",
    content: `### Засвар үйлчилгээний хэлтэс

Барловорлд Монгол ХХК-н Засвар үйлчилгээний хэлтэс нь Монгол орны өнцөг булан бүрт  болон УБ хотод САТ, САТ-бус тоног төхөөрөмжийн их засвар, дуудлагын засвар үйлчилгээ, тоног төхөөрөмжийн доголдлыг оношлох, техникийн модернизаци хийх, задаргаа-угсаргаа хийх, оношилгоо болон бусад засвартай холбоотой үйлчилгээг хийж байна. Уг хэлтэс нь 100 гаруй мэргэжлийн механикч, 20 гаруй удирдлагын ажилчидтай бөгөөд үүнд хөдөө орон нутгийн засвар үйлчилгээний баг, УБ хот дахь засвар үйлчилгээний баг,САТ-ын бус тоног төхөөрөмжийн засвар үйлчилгээний баг, Генераторын засвар үйлчилгээний баг, Техникийн Зөвлөх баг, Засварын Бүртгэлийн ажилтантай үйл ажиллагаа явуулж байна. Мэргэжлийн чанартай үйлчилгээ, байгаль орчин хамгаалах хүрээнд ISO9001:2015, OHSAS18001:2007 стандартыг хэрэгжүүлж, САТ-ын бохирдлын хяналтын 4 од болон САТ-ын сертификажсан их засварыг хийх эрхтэй.  
  

*   **Дуудлагын засвар үйлчилгээ**

УБ хотод төвтэй дуудлагын засвар үйлчилгээний хэлтэс маань Монгол орон даяар 24/7 үйлчилгээг үзүүлдэг. 50 гаруй мэргэжлийн механикчид, 20 орчим хүргэлтийн автомашин, хөдөө орон нутагт байрлах гурван салбар нь танд бүх төрлийн засвар үйлчилгээ,оношилгоо, угсралт, задаргааг санал болгож байна.  
  
  

*   **УБ хот дахь засвар үйлчилгээний хэлтэс**

УБ хотод 2 өндрийн кран (3.2T, 10T), 9 тусгай засварын лифт (хэмжээ 773, D9, 980, 390, г.м), тосны цэг (шүүлтүүр болон хуваарилах систем)-ээр тоноглогдсон 975 м2  засвар үйлчилгээний талбай бий. УБ хот дахь засвар үйлчилгээний хэлтэс нь Катерпилларын Бохирдлын Эсрэг Хяналтын 4 одтой бөгөөд 350 м2 талбайтай том тоног төхөөрөмж угаах угаалгын хэсэгтэй. 13 мэргэжлийн механикчид 20 гаруй жилийн хугацаанд 70 гаруй автомашины их засварыг хийсэн туршлагатай.  
  

**2.3.** **САТ-** **бус тоног төхөөрөмжийн засвар үйлчилгээ**

САТ-бус тоног төхөөрөмж болох SEM бульдозер, Allmand-ын гэрэл, Genie өргөгч төхөөрөмж, AGCO болон зам барилга, хөдөө аж ахуйн бүхий л төрлийн тоног төхөөрөмжид САТ-бус тоног төхөөрөмж засварын 18 механикчид ерөнхий үйлчилгээ, угсралт, холболт гэх мэт үйлчилгээг хийж үзүүлэх болно. УБ хот дахь САТ- бус тоног төхөөрөмжийн хэлтэс нь 375 м2 талбай бүхий бүрэн тоноглогдсон Igloo засварын хэсэгтэй. 
18 механикчид маань хөдөө орон нутагт засвар үйлчилгээ хийхэд зориулагдсан гурван автомашинтай.

САТ-бус тоног төхөөрөмж засварын хэлтэс нь УБ, Дархан болон Ханбогд гэсэн 3 салбартай.  
  

**2.4.** **Эрчим хүчний төхөөрөмжийн засвар үйлчилгээ**

Үйлдвэрийн генераторын засвар, угсаргаа, төлөвлөгөөт үйлчилгээ, доголдлыг оношлох, засварлах үйлчилгээг мэргэжлийн 11 чадварлаг механикчид хийж гүйцэтгэх болно. ВАТТ нь 12kW-7.2MW хүчин чадалтай генераторыг борлуулдаг.

**2.5. Замын-Үүд дахь задаргааны хэсэг**

Замын -Үүд дахь салбарт Уул уурхайн бүх төрлийн тоног төхөөрөмжийн угсаргааг 450 м2 талбайтай засварын хэсэг болон 1,5 га талбайд хийж гүйцэтгэнэ. Тоног төхөөрөмжийн их биеийг гагнах болон бусад угсралтын ажлыг өвлийн улиралд ч хийх боломжтой засварын хаалттай хэсэгтэй. 
Механикчдад зориулсан тохилог гурван хүний багтаамжтай байр бий.

**2.6.** **Заамар тоног төхөөрөмжийн угсралт болон засварын хэсэг**

Заамар салбарт багажны өрөө, оффис, дөрвөн хүний орон сууц, сэлбэгийн агуулах багтсан 9000 м2 талбайтай газарт засварын баг хамт олон үйл ажиллагаа явуулж байна. Хоёр механикч, нэг сэлбэгийн ажилтан, нэг дуудлагын автомашин энэхүү салбарт тогтмол бий.

**2.7.** **Техникийн зөвлөх баг**

Энэхүү баг нь гурван засварын зөвлөх, нэг үйл ажиллагаа төлөвлөгч, нэг техникийн инженерийн хамтаар үйл ажиллагаа явуулж байгаа бөгөөд 
M&R болон засвар үйлчилгээний хэлтсийн менежментийн процессийг дэмжихэд чиглэгдсэн байдаг. Засварын зөвлөхүүд маань техникийн зөвлөгөө, техникийн шийдэл, инженерийн хөгжүүлэлт, засварчдад зориулсан ганцаарчилсан сургалтыг өгч засвар үйлчилгээний хэлтсийг дэмжиж ажиллаж байна. 
Үйлчилгээний зөвлөх багийн хамтаар Барловорлд Монгол ХХК нь алсын зайнаас утас болон цахим шууданг ашиглаж харилцагчийн тоног төхөөрөмжийн бүхий л асуудлыг шийдвэрлэх болно.

Үйл ажиллагаа төлөвлөгч нь их засвар, засвар төлөвлөх, тооцоолохын тулд Засвар Үйлчилгээний хэлтсийн хүрээнд Spicework ажлын систем болон Microsoft Project-ыг ашигладаг.

**2.8.** **Багажны өрөө**

Засвар үйлчилгээний хэлтэс нь бүх засвар үйлчилгээнд зориулагдсан тусгай багаж хэрэгсэлтэй багажны өрөөтэй. САТ болон САТ-ын бус тоног төхөөрөмжинд зориулагдсан тусгай багаж (750 орчим багаж)-ийг багажны ажилтан хариуцаж, хянаж байна.`,
    content_en: `### Засвар үйлчилгээний хэлтэс

Барловорлд Монгол ХХК-н Засвар үйлчилгээний хэлтэс нь Монгол орны өнцөг булан бүрт  болон УБ хотод САТ, САТ-бус тоног төхөөрөмжийн их засвар, дуудлагын засвар үйлчилгээ, тоног төхөөрөмжийн доголдлыг оношлох, техникийн модернизаци хийх, задаргаа-угсаргаа хийх, оношилгоо болон бусад засвартай холбоотой үйлчилгээг хийж байна. Уг хэлтэс нь 100 гаруй мэргэжлийн механикч, 20 гаруй удирдлагын ажилчидтай бөгөөд үүнд хөдөө орон нутгийн засвар үйлчилгээний баг, УБ хот дахь засвар үйлчилгээний баг,САТ-ын бус тоног төхөөрөмжийн засвар үйлчилгээний баг, Генераторын засвар үйлчилгээний баг, Техникийн Зөвлөх баг, Засварын Бүртгэлийн ажилтантай үйл ажиллагаа явуулж байна. Мэргэжлийн чанартай үйлчилгээ, байгаль орчин хамгаалах хүрээнд ISO9001:2015, OHSAS18001:2007 стандартыг хэрэгжүүлж, САТ-ын бохирдлын хяналтын 4 од болон САТ-ын сертификажсан их засварыг хийх эрхтэй.  
  

*   **Дуудлагын засвар үйлчилгээ**

УБ хотод төвтэй дуудлагын засвар үйлчилгээний хэлтэс маань Монгол орон даяар 24/7 үйлчилгээг үзүүлдэг. 50 гаруй мэргэжлийн механикчид, 20 орчим хүргэлтийн автомашин, хөдөө орон нутагт байрлах гурван салбар нь танд бүх төрлийн засвар үйлчилгээ,оношилгоо, угсралт, задаргааг санал болгож байна.  
  
  

*   **УБ хот дахь засвар үйлчилгээний хэлтэс**

УБ хотод 2 өндрийн кран (3.2T, 10T), 9 тусгай засварын лифт (хэмжээ 773, D9, 980, 390, г.м), тосны цэг (шүүлтүүр болон хуваарилах систем)-ээр тоноглогдсон 975 м2  засвар үйлчилгээний талбай бий. УБ хот дахь засвар үйлчилгээний хэлтэс нь Катерпилларын Бохирдлын Эсрэг Хяналтын 4 одтой бөгөөд 350 м2 талбайтай том тоног төхөөрөмж угаах угаалгын хэсэгтэй. 13 мэргэжлийн механикчид 20 гаруй жилийн хугацаанд 70 гаруй автомашины их засварыг хийсэн туршлагатай.  
  

**2.3.** **САТ-** **бус тоног төхөөрөмжийн засвар үйлчилгээ**

САТ-бус тоног төхөөрөмж болох SEM бульдозер, Allmand-ын гэрэл, Genie өргөгч төхөөрөмж, AGCO болон зам барилга, хөдөө аж ахуйн бүхий л төрлийн тоног төхөөрөмжид САТ-бус тоног төхөөрөмж засварын 18 механикчид ерөнхий үйлчилгээ, угсралт, холболт гэх мэт үйлчилгээг хийж үзүүлэх болно. УБ хот дахь САТ- бус тоног төхөөрөмжийн хэлтэс нь 375 м2 талбай бүхий бүрэн тоноглогдсон Igloo засварын хэсэгтэй. 
18 механикчид маань хөдөө орон нутагт засвар үйлчилгээ хийхэд зориулагдсан гурван автомашинтай.

САТ-бус тоног төхөөрөмж засварын хэлтэс нь УБ, Дархан болон Ханбогд гэсэн 3 салбартай.  
  

**2.4.** **Эрчим хүчний төхөөрөмжийн засвар үйлчилгээ**

Үйлдвэрийн генераторын засвар, угсаргаа, төлөвлөгөөт үйлчилгээ, доголдлыг оношлох, засварлах үйлчилгээг мэргэжлийн 11 чадварлаг механикчид хийж гүйцэтгэх болно. ВАТТ нь 12kW-7.2MW хүчин чадалтай генераторыг борлуулдаг.

**2.5. Замын-Үүд дахь задаргааны хэсэг**

Замын -Үүд дахь салбарт Уул уурхайн бүх төрлийн тоног төхөөрөмжийн угсаргааг 450 м2 талбайтай засварын хэсэг болон 1,5 га талбайд хийж гүйцэтгэнэ. Тоног төхөөрөмжийн их биеийг гагнах болон бусад угсралтын ажлыг өвлийн улиралд ч хийх боломжтой засварын хаалттай хэсэгтэй. 
Механикчдад зориулсан тохилог гурван хүний багтаамжтай байр бий.

**2.6.** **Заамар тоног төхөөрөмжийн угсралт болон засварын хэсэг**

Заамар салбарт багажны өрөө, оффис, дөрвөн хүний орон сууц, сэлбэгийн агуулах багтсан 9000 м2 талбайтай газарт засварын баг хамт олон үйл ажиллагаа явуулж байна. Хоёр механикч, нэг сэлбэгийн ажилтан, нэг дуудлагын автомашин энэхүү салбарт тогтмол бий.

**2.7.** **Техникийн зөвлөх баг**

Энэхүү баг нь гурван засварын зөвлөх, нэг үйл ажиллагаа төлөвлөгч, нэг техникийн инженерийн хамтаар үйл ажиллагаа явуулж байгаа бөгөөд 
M&R болон засвар үйлчилгээний хэлтсийн менежментийн процессийг дэмжихэд чиглэгдсэн байдаг. Засварын зөвлөхүүд маань техникийн зөвлөгөө, техникийн шийдэл, инженерийн хөгжүүлэлт, засварчдад зориулсан ганцаарчилсан сургалтыг өгч засвар үйлчилгээний хэлтсийг дэмжиж ажиллаж байна. 
Үйлчилгээний зөвлөх багийн хамтаар Барловорлд Монгол ХХК нь алсын зайнаас утас болон цахим шууданг ашиглаж харилцагчийн тоног төхөөрөмжийн бүхий л асуудлыг шийдвэрлэх болно.

Үйл ажиллагаа төлөвлөгч нь их засвар, засвар төлөвлөх, тооцоолохын тулд Засвар Үйлчилгээний хэлтсийн хүрээнд Spicework ажлын систем болон Microsoft Project-ыг ашигладаг.

**2.8.** **Багажны өрөө**

Засвар үйлчилгээний хэлтэс нь бүх засвар үйлчилгээнд зориулагдсан тусгай багаж хэрэгсэлтэй багажны өрөөтэй. САТ болон САТ-ын бус тоног төхөөрөмжинд зориулагдсан тусгай багаж (750 орчим багаж)-ийг багажны ажилтан хариуцаж, хянаж байна.`,
  },
  {
    id: 3,
    title: "component",
    handle: "/service/component",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Service_3_CRC.jpg",
    youtube:
      '<iframe width="100%" height="490" src="https://www.youtube.com/embed/uv1jU85pxgs?wmode=transparent" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>',
    content: `### Агрегат засварын төв
              АЗТ нь КАТ-ийн машин, тоног төхөөрөмжийн голлох эд ангийг сэргээн засварлах зориулалт бүхий төв билээ. Улаанбаатар хотноо байрлах тус засварын төв нь Монгол улсын өнцөг булан бүрт тархсан Барловорлд Монгол ХХК-н бүх харилцагчиддаа хүрч ажиллах бүхий л нөөц бололцоог ханган ажиллаж байна. 
Дараах эд ангийг сэргээн засварладаг ба үүнд 
гидротрансформатор, хурдны хайрцаг, хойд тэнхлэгийн дамжлага, захын дамжуулагч зэрэг эд ангиуд, иж бүрэн, нарийвчилсан, техникийн хэрэслийг задлах түүнд шалгалт хийх, угсрах болон туршилтын үйл явцуудыг хийх, тэдгээр эд ангиудыг дахин шинээр авсан мэт засаж өгдөг ба манай үйлчлүүлэгчдэд илүү урт удаан хугацаанд тоног төхөөрөмжөө хэрэглэх боломжийг олгодогоороо давуу талтай. Энэхүү сэргээн завсаруудыг хийснээр харилцагчдын зүгээс ашиглалтын нийт зардал багасаж, тоног төхөөрөмжийн ашиглалт нэмэгдэх юм. 2018 оны Арваннэгдүгээр сарын 18-ны өдөр бид бүрэн шинэчлэлт хийн өргөжүүлсэн Засварын төвийн нээлтээ хийсэн. Тус өргөтгөлийн үеэр задаргааны 10 хэсэг, 
хүч дамжуулах ангийн 4 хэсэг, 
хөдөлгүүр угсралтын 5 хэсгийг өргөтгөн, хагас тулгууртай 9 кран (2тонн), 
гүүрэн кран 2 (15тонн), E-RAD электрон торк түлхүүр (2500 & 700 lb.-ft), цахилгаан сэрээт өргөгч, үйлдвэрийн хөлдөөгч (14 фут / -80c), техникийн хангамжийн чанарыг батлахад заводын тест хийхэд шаардлагатай Power test-ийн Хөдөлгүүрийн динамометр (3150 морины хүч хүртэлх), AIDCO 900C -ийн Гидравлик заводын тест (300 морины хүч) зэрэг сайжруулалт хийсэн.
Дээрх өргөжилтийн хүрээнд бидний хөдөлмөрийн бүтээмж сайжирснаар жил ирэх тусам харилцагчиддаа үзүүлэх үйлчилгээ нэмэгдэж үүнийг дагаад харилцагчдын маань бизнест ч тус нэмрээ үзүүлсээр байна. Тухайлбал, 2016 онд бид 108 эд анги сэргээн засварлаж байсан бол 2019 оны 11 сарын байдлаар 415 эд анги буюу нэг ээлжээр 3,8 дахин өсөлттэй үзүүлэлт гарсан. Бид цаашид нэг ээлжээр 900-гаас дээш хүртэлх эд ангийг сэргээн завсарлахаар зорин ажиллаж байна. 
Манай АЗТ нь нийт 95 ажилтантай ба үүний 65 нь нарийн мэргэшсэн, сайн бэлтгэгдсэн засварчид бөгөөд та бүхэнд дэлхийн жишигт нийцсэн, ISO стандарт хангасан, Катерпиллараар итгэмжлэгдсэн үйлчилгээг үзүүлэхээр бүрэн хүчин чармайлт гарган ажиллаж байна. Тус засварын төв нь харилцагчиддаа олон төрлийн засварын үйлчилгээг санал болгодог. Үүнд: Эд анги солилцооны хөтөлбөр, суурь үнэ, тухайн эд ангид учирсан эвдрэлд суурилсан үнийн санал, Реман болон шинэ эд анги зэрэг бүхий л төрлийн үйлчилгээ, үнэлгээг та бүхний хэрэгцээ шаардлага, төсөв санхүүд нийцүүлэх зорилгоор санал болгож байна. Тухайлбал, Сэргээн засварласан эд ангийг сонирхож буй харилцагч бидний эд ангийн сангаас өөрт шаардлагатай боломжит ангийг сонгон авах боломжтой, бусад сонголтуудаас мөн харилцагч өөрт тохирсон шийдлийг олоход манай ажилчид бүх бололцоог бүрэн тайлбарлаж өгөх болно. Эдгээр бүх Агрегат засварын Боломжит хувилбарууд тус бүрт Баталгааг давхар олгодог. Харилцагч КАТ-ын үзүүлэлтэд чанартай сэргээн засвар хийгдэнэ гэдэгт бидэнд бүрэн итгэж болно. Түүнчлэн, хэрэглэгчийн шаардлагатай тохиолдолд бид тухайн тоног төхөөрөмжийг эргүүлэн угсарч, хэрэглэгчид буцаан олгох боломжтой. Монгол улсын тэргүүлэх компаниуд болох Тийсс Монголиа ХХК, Оюу Толгой ХХК, Хишиг Арвин Индустриал ХХК, Багануур ХК, Баян Айраг Эксплорэйшн ХХК, Цагаан Өвөлжөө ХХК зэрэг компаниуд бидэнтэй хамтран ажилладаг.`,
    content_en: `# Component Rebuild Center (CRC)

## Component Service Strategy

The **Component Rebuild Center (CRC)** located in **Ulaanbaatar** repairs and rebuilds critical CAT machinery components for **Barloworld Mongolia LLC** customers throughout Mongolia. 

We process:
- Engines  
- Torque Converters  
- Transmissions  
- Differentials  
- Wheel Groups (front and/or rear)  
- Gearboxes  
- Cylinders  
- Others  

Using a comprehensive process of **disassembly**, **inspection**, **ordering or salvaging parts**, **assembly**, and **testing**, we return components to operational or like-new condition. This extends equipment lifespan, increases component utilization, and reduces operating costs.

Our expanded and renovated CRC features enhanced capabilities:
- 5 powertrain disassembly bays  
- 5 engine disassembly bays  
- 1 express bay for customer emergencies  
- 5 powertrain assembly sections  
- 5 engine assembly sections  

We've invested in advanced equipment, including:
- Overhead cranes, jib cranes, semi-gantry cranes  
- Hydraulic presses, steam washer machines, large tank ultrasonic cleaner  
- E-RAD electronic torque wrenches, forklifts, industrial freezers  
- Bearing induction heaters  
- High-capacity engine dynamometer (320–3,150 horsepower)  
- Hydraulic bench tester (300 horsepower, 2550 rpm)  

This expansion has significantly improved **quality**, **productivity**, and **service offerings**, with services increasing year over year—contributing directly to our customers' success.

### Our Team

CRC staff includes **110 employees**:
- 60 component technicians  
- 19 salvage machinists  

We are committed to providing **world-class services**, certified by:
- **ISO**
- **Caterpillar Best in Class**

### Our Services

We offer a full range of repair services:
- Partial repairs at different levels  
- Full rebuilds under contracts such as:
  - Strip and quote  
  - Repair and return  
  - Flat rates  
  - Components exchange program  

These are supported by:
- New parts  
- Reman parts  
- Parts kits  
- Salvaged parts  
- Repaired components  
- Remanufactured components  

Customers can choose the most suitable component repair option from our library, with expert guidance for optimal solutions. All unit repairs are **warranty-backed** and meet **CAT specifications**.

We also offer **equipment reassembly and return** upon request.

### Our Customers

We proudly serve leading Mongolian companies, including:
- **Thiess Mongolia LLC**  
- **Oyu Tolgoi LLC**  
- **MAK**  
- **Khishig Arvin Industrial LLC**  
- **Baganuur JSC**  
- **Bayan Airag Exploration LLC**  
- **Tsagaan Uvuljoo LLC**  
- *...and more*

**Date:** April 9, 2025
`,
  },
  {
    id: 4,
    title: "field",
    handle: "/service/field",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Service_4_Field.jpg",
    youtube: "",
    content: `### ДУУДЛАГЫН ЗАСВАР
Манай дуудлагын засварын үйлчилгээ нь Улаанбаатарт төвтэй, Монгол улсын аль ч хэсэгт богино хугацаанд дуудлагаар очиж засвар үйлчилгээ үзүүлдэг 24 цагийн хөдөлгөөнт шуурхай үйлчилгээ юм. Засвар үйлчилгээний үндсэн тоноглол багаж хэрэгслээр бүрэн тоноглогдсон туулах чадвар сайтай тусгай автомашин хөлөглөсөн өргөн туршлага, өндөр мэдлэг, зэрэглэлтэй механикууд жилийн аль ч улиралд, дуудсан газарт тань хүрч очин үйлчилж таны машины эвдрэл гэмтлийг оношлон засварлана.  

![](http://webnew.barloworld.mn/images/uploads2/SERVIC_20211109.jpg)  

**КАТЕРПИЛЛАРЫН ХЯЗГААРЛАГДМАЛ БАТАЛГАА**

  

**Катерпиллар компани., буюу түүний салбар (“Катерпиллар”) компаниуд нь өөрийн борлуулсан шинэ бүтээгдэхүүнийн материалын чанар болон угсаргаанд дараах баталгааг өгдөг. Үүнд:**

Газар шороо, барилга тээвэрлэлт, ойн болон зам хучлагт зориулагдсан техникүүд (доор дурьдагдаагүй бол)Адил төстэй техникийн дагалдах хэрэгсэл/багаж сэлбэг (Cat® ажлын багажны баталгаа буюу өөр үйлчдвэрлэгчийн баталгаанд үл хамаарах тохиолдолд). Гидравлик алханд ашиглагдах сэлбэг болон compact plate тус баталгаанд үл хамаарна.Түүнчлэн САТ -ын газар шорооны ажлын тодорхой төхөөрөмжүүдийн эвдрэл болон хог булагчийн нягтуурлагчийн элэгдэлд нэмэлт баталгаа өгдөг.Энэхүү баталгаа нь дараах зүйлст үл хамаарна. Үүнд:  
• CАТ зай• Mobil-trac ремень, олон үйлдэлт ачигчийн резин гинж, compact гижит ачигч болон мини гидравлик экскавотор  
• CАТ ажлын багаж• 424 нэг шанагат ачигч, 216/226 загварын хөдөлгөөнт тавцантай ачигч болон Энэтхэгт   борлуулагдах 320 загварын экскаватор  
• Prentice ойн техник  
• Газрын гүний техник  
• Евроазийн тусгаар улсуудын хамтын нөхөрлөл (“CIS”) -д үл хамаарах бүс нутагт борлуулагдах 785, 789, 793, 794, 795, 796, 797 болон 798 загварын ачааны машинууд  
• Евроазийн тусгаар улсуудын хамтын нөхөрлөл (“CIS”) -д үл хамаарах бүс нутагт борлуулагдах 24 загварын моторт хусагч  
• Евроазийн тусгаар улсуудын хамтын нөхөрлөл (“CIS”) -д үл хамаарах бүс нутагт борлуулагдах 854, 992, 993, 994 загварын дугуйт ачигч  
• САТ -ын тээврийн хэрэгсэл (UTV)  
• АНУ болон Канад улсуулад борлуулагддаг Compact Track болон олон үйлдэлт ачигч, мини гидравлик экскаватор болон хөдөлгөөнт тавцантай ачигч  
Эдгээр бүтээгдэхүүнүүд нь Катерпилларын өөр баталгаанд хамрагддаг болно.  
Харин энэхүү баталгаа нь дараах нөхцөлүүдэд харъяалагдана. Үүнд:  
  
**Баталгаат хугацаа**

  
Шинэ машин техник болон түүний дагалдах хэрэгсэл/багаж сэлбэгийн баталгаат хугацаа нь хязгааргүй мот.цагтайгаар 12 сар байх ба энэхүү хугацаа нь эхний хэрэглэгчид бүтээгдэхүүн хүргэгдсэн өдрөөс эхэлж хэрэгжинэ.  
  
Жич:  
• Compact дугуйтай ачигч, олон үйлдэлт ачигч, мини гидравлик экскаватор, хөдөлгөөнт тавцантай ачигч болон Compact гинжит ачигч зэрэг гидравлик шугамын хялбар залгаж/салгах бүрэлдэхүүн эд анги  
• Dragline экскаватор, цахилгаан shovel экскаватор, чулуу зайлуулагч, чулуун тэжээгүүр, чулуу олборлогч, чулуун конвейер болон чулуун дээврийн тулгуур зэргийн баталгаат хугацаа нь 24 сараас ихгүй байна.  
Катерпилларын үүрэг хариуцлага  
Хэрэв баталгаат хугацаандаа, Катерпиллар Will, ажиллах ёстой мот цагтаа эсвэл САТ дилерийн байршил дээр байх үед ямарваа нэгэн материалын гажиг, эсвэл угсаргааны алдаа илэрвэл Катерпиллар нь дараах хариуцлагыг хүлээнэ. Үүнд:  
Эвдрэлийг засахад шаардагдах шинэ, сэргээн засварласан, эсвэл Катерпиллар-ын баталгаат засвараас гарсан баталгаат сэлбэг/эд ангиар хангах (Катерпиллар -ын сонголтоор)  
Жич:  
Тус баталгааны тавигдах нөхцөлд хамаарах шинэ, дахин үйлдвэрлэгдсэн, эсвэл Катерпиллараар баталгаажин засварлагдсан сэлбэг, эсвэл эд анги, угсаргдсан эд анги   
  
Жич:  
Тус баталгааны нөхцөлд хамаарах машины оргинал сэлбэг болон эд ангийг тухайн баталгаат хугацаанд шинэ, сэргээн засварласан болон Катерпиллараар баталгаажин засварлагдсан сэлбэг болон эд ангиудаар солино. Энэхүү баталгаагаар солигдсон эд ангиуд нь Катерпилларын өмч болно.  
  
• Тос, фильтр, антифриз болон эвдрэлээс болж хэрэгцээнээс гарсан бусад сервисийн зүйлсийг шинээр солих15  
• Эвдрэлийг засварлахад шаардагдах зохистой хөдөлмөрөөр хангах  
  
**Хэрэглэгчийн үүрэг хариуцлага**

  
• Эхний хэрэглэгчид хүргэгдсэн баримт нотолгоог гаргах  
• “Катерпиллар -ын үүрэг хариуцлага” -т заагдсанаас өөр хөдөлмөрийн хөлсний төлбөрийг хариуцах  
• Катерпиллар -ын үүрэг хариуцлага” -т заагдсанаас өөр-т заагдсанаас өөр тээврийн хөлсний төлбөрийг хариуцах  
• Дээд зэрэглэлийн, эсвэл илүү цагийн хөдөлмөрийн хөлсийг хариуцах  
• Сэлбэг тээвэрлэлтийн хөлс нь хэвийн тохиолдлоос хэтэрсэн гэж үзвэл  
• Дотоодын татвар /байдаг бол/  
• Асуудлыг тодорхойлоход чиглэсэн зардлыг хариуцана /Катерпиллар -ын угсаргааны алдаа, эсвэл материалын дефект биш бол/  
• Баталгаат хугацаанд тохиолдсон эвдрэлийн талаар зохих цагт нь мэдэгдэх, бүтээгдэхүүнийг засварт бэлтгэх  
• Шаардлагатай сервис үйлчилгээг хэрэгжүүлэх (Зохих түлш, тос, шингэн, тосол гэх мэтийг ашиглах), энгийн элэгдэлтэй зүйлсийг солих  
• Бүх цахим хадлагдсан мэдээллэлд нэвтрэх боломжийг Катерпилларт бүрдүүлж өгөх  
  
**Хязгаарлагдмал нөхцөл**

  
Катерпиллар нь дараах тохиолдолд хариуцлага үүрэхгүй. Үүнд:  
•   Катерпиллар -ын хувьд зохимжгүй гэж үзсэн ашиглалт, суурьлуулалтаас болж эвдрэл үүсэх  
• Катерпиллар -аас борлуулагдаагүй буюу хүлээн зөвшөөрөгдөөгүй элдэв дагалдах хэрэгсэл, тоноглол, сэлбэг зэргээс болж эвдрэл үүсэх  
• Буруу ашиглалт, буруу хадгалалт, эсвэл буруу засвараас болж эвдрэл үүсэх  
• Бүтээгдэхүүнд тохиож болзошгүй асуудлын талаар сануулга авсан ч хэрэглэгч бүтээгдэхүүнээ цаг тухайд нь бэлэн байлгаж чадаагүй хойшлуулсанаас болж эвдрэл`,
    content_en: `### ДУУДЛАГЫН ЗАСВАР
Манай дуудлагын засварын үйлчилгээ нь Улаанбаатарт төвтэй, Монгол улсын аль ч хэсэгт богино хугацаанд дуудлагаар очиж засвар үйлчилгээ үзүүлдэг 24 цагийн хөдөлгөөнт шуурхай үйлчилгээ юм. Засвар үйлчилгээний үндсэн тоноглол багаж хэрэгслээр бүрэн тоноглогдсон туулах чадвар сайтай тусгай автомашин хөлөглөсөн өргөн туршлага, өндөр мэдлэг, зэрэглэлтэй механикууд жилийн аль ч улиралд, дуудсан газарт тань хүрч очин үйлчилж таны машины эвдрэл гэмтлийг оношлон засварлана.  

![](http://webnew.barloworld.mn/images/uploads2/SERVIC_20211109.jpg)  

**КАТЕРПИЛЛАРЫН ХЯЗГААРЛАГДМАЛ БАТАЛГАА**

  

**Катерпиллар компани., буюу түүний салбар (“Катерпиллар”) компаниуд нь өөрийн борлуулсан шинэ бүтээгдэхүүнийн материалын чанар болон угсаргаанд дараах баталгааг өгдөг. Үүнд:**

Газар шороо, барилга тээвэрлэлт, ойн болон зам хучлагт зориулагдсан техникүүд (доор дурьдагдаагүй бол)Адил төстэй техникийн дагалдах хэрэгсэл/багаж сэлбэг (Cat® ажлын багажны баталгаа буюу өөр үйлчдвэрлэгчийн баталгаанд үл хамаарах тохиолдолд). Гидравлик алханд ашиглагдах сэлбэг болон compact plate тус баталгаанд үл хамаарна.Түүнчлэн САТ -ын газар шорооны ажлын тодорхой төхөөрөмжүүдийн эвдрэл болон хог булагчийн нягтуурлагчийн элэгдэлд нэмэлт баталгаа өгдөг.Энэхүү баталгаа нь дараах зүйлст үл хамаарна. Үүнд:  
• CАТ зай• Mobil-trac ремень, олон үйлдэлт ачигчийн резин гинж, compact гижит ачигч болон мини гидравлик экскавотор  
• CАТ ажлын багаж• 424 нэг шанагат ачигч, 216/226 загварын хөдөлгөөнт тавцантай ачигч болон Энэтхэгт   борлуулагдах 320 загварын экскаватор  
• Prentice ойн техник  
• Газрын гүний техник  
• Евроазийн тусгаар улсуудын хамтын нөхөрлөл (“CIS”) -д үл хамаарах бүс нутагт борлуулагдах 785, 789, 793, 794, 795, 796, 797 болон 798 загварын ачааны машинууд  
• Евроазийн тусгаар улсуудын хамтын нөхөрлөл (“CIS”) -д үл хамаарах бүс нутагт борлуулагдах 24 загварын моторт хусагч  
• Евроазийн тусгаар улсуудын хамтын нөхөрлөл (“CIS”) -д үл хамаарах бүс нутагт борлуулагдах 854, 992, 993, 994 загварын дугуйт ачигч  
• САТ -ын тээврийн хэрэгсэл (UTV)  
• АНУ болон Канад улсуулад борлуулагддаг Compact Track болон олон үйлдэлт ачигч, мини гидравлик экскаватор болон хөдөлгөөнт тавцантай ачигч  
Эдгээр бүтээгдэхүүнүүд нь Катерпилларын өөр баталгаанд хамрагддаг болно.  
Харин энэхүү баталгаа нь дараах нөхцөлүүдэд харъяалагдана. Үүнд:  
  
**Баталгаат хугацаа**

  
Шинэ машин техник болон түүний дагалдах хэрэгсэл/багаж сэлбэгийн баталгаат хугацаа нь хязгааргүй мот.цагтайгаар 12 сар байх ба энэхүү хугацаа нь эхний хэрэглэгчид бүтээгдэхүүн хүргэгдсэн өдрөөс эхэлж хэрэгжинэ.  
  
Жич:  
• Compact дугуйтай ачигч, олон үйлдэлт ачигч, мини гидравлик экскаватор, хөдөлгөөнт тавцантай ачигч болон Compact гинжит ачигч зэрэг гидравлик шугамын хялбар залгаж/салгах бүрэлдэхүүн эд анги  
• Dragline экскаватор, цахилгаан shovel экскаватор, чулуу зайлуулагч, чулуун тэжээгүүр, чулуу олборлогч, чулуун конвейер болон чулуун дээврийн тулгуур зэргийн баталгаат хугацаа нь 24 сараас ихгүй байна.  
Катерпилларын үүрэг хариуцлага  
Хэрэв баталгаат хугацаандаа, Катерпиллар Will, ажиллах ёстой мот цагтаа эсвэл САТ дилерийн байршил дээр байх үед ямарваа нэгэн материалын гажиг, эсвэл угсаргааны алдаа илэрвэл Катерпиллар нь дараах хариуцлагыг хүлээнэ. Үүнд:  
Эвдрэлийг засахад шаардагдах шинэ, сэргээн засварласан, эсвэл Катерпиллар-ын баталгаат засвараас гарсан баталгаат сэлбэг/эд ангиар хангах (Катерпиллар -ын сонголтоор)  
Жич:  
Тус баталгааны тавигдах нөхцөлд хамаарах шинэ, дахин үйлдвэрлэгдсэн, эсвэл Катерпиллараар баталгаажин засварлагдсан сэлбэг, эсвэл эд анги, угсаргдсан эд анги   
  
Жич:  
Тус баталгааны нөхцөлд хамаарах машины оргинал сэлбэг болон эд ангийг тухайн баталгаат хугацаанд шинэ, сэргээн засварласан болон Катерпиллараар баталгаажин засварлагдсан сэлбэг болон эд ангиудаар солино. Энэхүү баталгаагаар солигдсон эд ангиуд нь Катерпилларын өмч болно.  
  
• Тос, фильтр, антифриз болон эвдрэлээс болж хэрэгцээнээс гарсан бусад сервисийн зүйлсийг шинээр солих15  
• Эвдрэлийг засварлахад шаардагдах зохистой хөдөлмөрөөр хангах  
  
**Хэрэглэгчийн үүрэг хариуцлага**

  
• Эхний хэрэглэгчид хүргэгдсэн баримт нотолгоог гаргах  
• “Катерпиллар -ын үүрэг хариуцлага” -т заагдсанаас өөр хөдөлмөрийн хөлсний төлбөрийг хариуцах  
• Катерпиллар -ын үүрэг хариуцлага” -т заагдсанаас өөр-т заагдсанаас өөр тээврийн хөлсний төлбөрийг хариуцах  
• Дээд зэрэглэлийн, эсвэл илүү цагийн хөдөлмөрийн хөлсийг хариуцах  
• Сэлбэг тээвэрлэлтийн хөлс нь хэвийн тохиолдлоос хэтэрсэн гэж үзвэл  
• Дотоодын татвар /байдаг бол/  
• Асуудлыг тодорхойлоход чиглэсэн зардлыг хариуцана /Катерпиллар -ын угсаргааны алдаа, эсвэл материалын дефект биш бол/  
• Баталгаат хугацаанд тохиолдсон эвдрэлийн талаар зохих цагт нь мэдэгдэх, бүтээгдэхүүнийг засварт бэлтгэх  
• Шаардлагатай сервис үйлчилгээг хэрэгжүүлэх (Зохих түлш, тос, шингэн, тосол гэх мэтийг ашиглах), энгийн элэгдэлтэй зүйлсийг солих  
• Бүх цахим хадлагдсан мэдээллэлд нэвтрэх боломжийг Катерпилларт бүрдүүлж өгөх  
  
**Хязгаарлагдмал нөхцөл**

  
Катерпиллар нь дараах тохиолдолд хариуцлага үүрэхгүй. Үүнд:  
•   Катерпиллар -ын хувьд зохимжгүй гэж үзсэн ашиглалт, суурьлуулалтаас болж эвдрэл үүсэх  
• Катерпиллар -аас борлуулагдаагүй буюу хүлээн зөвшөөрөгдөөгүй элдэв дагалдах хэрэгсэл, тоноглол, сэлбэг зэргээс болж эвдрэл үүсэх  
• Буруу ашиглалт, буруу хадгалалт, эсвэл буруу засвараас болж эвдрэл үүсэх  
• Бүтээгдэхүүнд тохиож болзошгүй асуудлын талаар сануулга авсан ч хэрэглэгч бүтээгдэхүүнээ цаг тухайд нь бэлэн байлгаж чадаагүй хойшлуулсанаас болж эвдрэл`,
  },
  {
    id: 5,
    title: "repair",
    handle: "/service/repair",
    image: "/assets/img/service/repair.jpg",
    youtube:
      '<iframe width="100%" height="490" src="https://www.youtube.com/embed/hyi6o8qyS24?wmode=transparent" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>',
    content: `### ЗАСВАРЫН ХУВИЛБАР ГЭЖ ЮУ ВЭ?

![](http://www.wagnerasia.com/images/uploads2/2020-12-25-09-25-32wae_Picture1111.jpg)  

Засварын хувилбарууд гэдэг нь Катерпилларын дилерийн зүгээс тоног төхөөрөмжийн насжилтан дээр үндэслэн харилцагчдад санал болгож байгаа техник үйлчилгээ, энгийн болон зайлшгүй шаардлагатай засваруудад зориулсан сонголтууд юм. Засварын сонголтын үнийн хувьд тухайн сонголтонд багтаж байгаа ажлын цар хүрээнээс хамааран тодорхойлогдоно.  
  

### ЯАГААД ЗАСВАРЫН ХУВИЛБАРУУД ГЭЖ?

CAT үндсэн эд ангиуд нь дахин сэргээн засварлагдахаар бүтээгдсэн байдаг. Бид энэхүү сэргээн засварлагдахуйц давуу тал дээр үндэслэн тоног төрөөхөмжийн насжилтыг уртасгах үүднээс тухайн эд ангийн элэгдэлд тохирсон засварын сонголтуудыг харилцагчдадаа санал болгож байна. Манай мэргэжилтнүүд танд хамгийн зөв засварын сонголтыг хийхэд зөвхөн нийлүүлэгчийн зүгээс биш харин таны итгэлтэй бизнес түншийн үүднээс туслах болно.`,
    content_en: `# REPAIR OPTIONS

**Extend Life Cycle and Maximize Value with Repair Options Tailored to Your Needs**

When you plan and repair before a failure, you are making a great economic decision for your operation. CAT machines and components are designed to last several lives, with only replacing the internal parts which have had normal wear caused by the equipment utilization. On the other hand, if a part, component, and/or equipment fails, the cost to recover it could be up to 2.5 times the value of the repair before failure. Studies agree that 90% of catastrophic failures could have been avoided if the affected parts had been intervened, with due anticipation.

We have streamlined our Repair Options to provide you with an easier decision-making process. Whether you prioritize cost and/or minimizing downtime risk, aim to prolong the lifespan of components, or prefer to retain your own equipment, we have the right solution for your needs.

## REPAIR

Extend the life of your components or repair to your needs and specifications at minimal cost based on component operational condition, mid-life maintenance, and repairs to ensure you get maximum life from your components at the lowest cost per hour.

* **Level 1 = Cleaning and Resealing:** This repair might cost about 10% of a new component's value.
* **Level 2 = Cleaning, Resealing, and Parts Reconditioning:** This repair might cost about 15% of a new component's value.
* **Level 3 = Cleaning, Resealing, Parts Reconditioning, and Rebearing Based on Condition:** This repair might cost about 30% of a new component's value.
* **Level 4 = Cleaning, Resealing, Parts Reconditioning, and Full Rebearing:** This repair might cost about 40% of a new component's value.

## REBUILD

Balancing cost with downtime or when retaining ownership is important, you can have your own iron rebuilt through BWM, your CAT dealer to a Caterpillar guideline "as-new" standard and save from rebuild lane efficiency and OEM certified parts reusability.

This option might cost about 80% of a new component's value.

## BWM COMPONENT EXCHANGE PROGRAM

Saving you money at every turn with a faster, better option for components repair or components replacement in a timely of components is crucial for keeping your fleet on the job and performing well.

BWM Component Exchange Program enables you to save money while getting high-quality replacement components. Our program lets you swap worn or timed-out components for a Cat product rebuilt by experts of BWM.

When you purchase a component from BWM, you will receive a credit for returning your old, worn-out core. This amount will offset the purchase price of the new exchange component, leading to reduced owning and operating costs. BWM then takes that core and remanufactures it, bringing it back to "like new" condition. These are reliable components undergo a comprehensive rebuilding process to restore them to like-new condition. They also undergo rigorous testing to ensure they're ready to perform at your sites. With universal warranty coverage, you get protection and peace of mind.

This option might cost about 70% of a new component's value.

The BWM Component Exchange Program encompasses many of the essential components you need to maximize your fleet's performance, such as:

* Engines
* Torque Converters
* Transmissions
* Differentials
* Front and Rear Wheels
* Front and Rear Axles
* Brake Groups
* Drive Groups
* Suspensions
* Hydraulic cylinders

## CAT® REMAN

Components and/or parts (remanufactured) are designed and intervened at the factory to offer the best quality, price, and durability option in the market while they have the same warranty of a Premium (new) part, guaranteed just for one life.

With CAT® REMAN components/parts, you can save money compared to a Premium part price, delivering your used CAT® part as partial payment, which, according to its conditions, can represent full core refund or partial core refund range from 20% to 60% of the total value of the Reman part.

This option might cost about 85% of a new component's value.

## CAT® NEW

If in your operation you must maintain the minimum downtime risk, a complete replacement with a new factory component is another way. Caterpillar components are built to be rebuilt if you need this option, offering longer-term reusability and cost benefits beyond the initial purchase, and the seed of a new component can provide the lowest risk.

**Note:** Final repair cost will be provided after disassembly and component evaluation.
# Available Repair Options

Please find below the list of available repair options along with downloadable links to detailed technical brochures.

|Component|Machine Model|Machine Serial|Repair Details and Price Estimates|
|---|---|---|---|
|Engine|793D|FDB|[Technical Brochure Link](/en/service/repair/793d)|
|Torque Converter|793D|FDB|[Technical Brochure Link](/en/service/repair/793d)|
|Transmission|793D|FDB|[Technical Brochure Link](/en/service/repair/793d)|
|Differential|793D|FDB|[Technical Brochure Link](/en/service/repair/793d)|
|Wheel GP-Rear|793D|FDB|[Technical Brochure Link](/en/service/repair/793d)|
|Wheel GP-Front|793D|FDB|[Technical Brochure Link](/en/service/repair/793d)|
|Suspension GP-Front|793D|FDB|[Technical Brochure Link](/en/service/repair/793d)|
|Suspension GP-Rear|793D|FDB|[Technical Brochure Link](/en/service/repair/793d)|
|Engine|785C|APX|[Technical Brochure Link](/en/service/repair/785C)|
|Torque Converter|785C|APX|[Technical Brochure Link](/en/service/repair/785C)|
|Transmission|785C|APX|[Technical Brochure Link](/en/service/repair/785C)|
|Differential|785C|APX|[Technical Brochure Link](/en/service/repair/785C)|
|Wheel GP-Rear|785C|APX|[Technical Brochure Link](/en/service/repair/785C)|
|Wheel GP-Front|785C|APX|[Technical Brochure Link](/en/service/repair/785C)|
|Suspension GP-Front|785C|APX|[Technical Brochure Link](/en/service/repair/785C)|
|Suspension GP-Rear|785C|APX|[Technical Brochure Link](/en/service/repair/785C)|
|Engine|777D|FKR - AGC - 3PR|[Technical Brochure Link](/en/service/repair/777D)|
|Engine|777E|KDZ - KDP|[Technical Brochure Link](/en/service/repair/777E)|
|Engine|777F|JRP|[Technical Brochure Link](/en/service/repair/777F)|
|Engine|777G|TNM|[Technical Brochure Link](/en/service/repair/777G)|
|Torque Converter|777D|FKR - AGC - 3PR|[Technical Brochure Link](/en/service/repair/777D)|
|Transmission|777D|FKR - AGC - 3PR|[Technical Brochure Link](/en/service/repair/777D)|
|Differential|777D|FKR - AGC - 3PR|[Technical Brochure Link](/en/service/repair/777D)|
|Wheel GP-Rear|777D|FKR - AGC - 3PR|[Technical Brochure Link](/en/service/repair/777D)|
|Wheel GP-Front|777D|FKR - AGC - 3PR|[Technical Brochure Link](/en/service/repair/777D)|
|Suspension GP-Rear|777D|FKR - AGC - 3PR|[Technical Brochure Link](/en/service/repair/777D)|
|Suspension GP-Front|777D|FKR - AGC - 3PR|[Technical Brochure Link](/en/service/repair/777D)|
|Transmission|777E|KDZ|[Technical Brochure Link](/en/service/repair/777E)|
|Torque Converter|777E|KDZ|[Technical Brochure Link](/en/service/repair/777E)|
|Suspension GP-Front|777E|KDZ|[Technical Brochure Link](/en/service/repair/777E)|
|Differential|777F|JRP|[Technical Brochure Link](/en/service/repair/777F)|
|Torque Converter|777F|JRP|[Technical Brochure Link](/en/service/repair/777F)|
|Wheel GP-Front|777F|JRP|[Technical Brochure Link](/en/service/repair/777F)|
|Transmission|777G|TNM|[Technical Brochure Link](/en/service/repair/777G)|
|Torque Converter|777G|TNM|[Technical Brochure Link](/en/service/repair/777G)|
|Differential|777G|TNM|[Technical Brochure Link](/en/service/repair/777G)|
|Wheel GP-Rear|777G|TNM|[Technical Brochure Link](/en/service/repair/777G)|
|Wheel GP-Front|777G|TNM|[Technical Brochure Link](/en/service/repair/777G)|
|Suspension GP-Rear|777G|TNM|[Technical Brochure Link](/en/service/repair/777G)|
|Engine|773D|NBJ|[Technical Brochure Link](/en/service/repair/773D)|
|Torque Converter|773D|NBJ|[Technical Brochure Link](/en/service/repair/773D)|
|Transmission|773D|NBJ|[Technical Brochure Link](/en/service/repair/773D)|
|Differential|773D|NBJ|[Technical Brochure Link](/en/service/repair/773D)|
|Wheel GP-Rear|773D|NBJ|[Technical Brochure Link](/en/service/repair/773D)|
|Wheel GP-Front|773D|NBJ|[Technical Brochure Link](/en/service/repair/773D)|
|Suspension GP-Rear|773D|NBJ|[Technical Brochure Link](/en/service/repair/773D)|
|Suspension GP-Front|773D|NBJ|[Technical Brochure Link](/en/service/repair/773D)|
|Engine|773E|BDA|[Technical Brochure Link](/en/service/repair/773E)|
|Engine|773E|KEG/ASK|[Technical Brochure Link](/en/service/repair/773E)|
|Engine|773E|PRB|[Technical Brochure Link](/en/service/repair/773E)|
|Torque Converter|773E|ASK|[Technical Brochure Link](/en/service/repair/773E)|
|Differential|773E|ASK|[Technical Brochure Link](/en/service/repair/773E)|
|Suspension GP-Rear|773E|ASK|[Technical Brochure Link](/en/service/repair/773E)|
|Suspension GP-Front|773E|ASK|[Technical Brochure Link](/en/service/repair/773E)|
|Torque Converter|773E|DJS|[Technical Brochure Link](/en/service/repair/773E)|
|Transmission|773E|DJS|[Technical Brochure Link](/en/service/repair/773E)|
|Suspension GP-Rear|773E|DJS|[Technical Brochure Link](/en/service/repair/773E)|
|Wheel GP-Rear|773E|KEG|[Technical Brochure Link](/en/service/repair/773E)|
|Suspension GP-Rear|773E|KEG|[Technical Brochure Link](/en/service/repair/773E)|
|Suspension GP-Front|773E|KEG|[Technical Brochure Link](/en/service/repair/773E)|
|Engine|D10T|RJG|[Technical Brochure Link](/en/service/repair/D10T)|
|Torque Converter|D10T|RJG|[Technical Brochure Link](/en/service/repair/D10T)|
|Transmission|D10T|RJG|[Technical Brochure Link](/en/service/repair/D10T)|
|Clutch & Brake GP-Steering|D10T|RJG|[Technical Brochure Link](/en/service/repair/D10T)|
|Drive GP-Final|D10T|RJG|[Technical Brochure Link](/en/service/repair/D10T)|
|Engine|D9R|WDM|[Technical Brochure Link](/en/service/repair/D9R)|
|Torque Converter|D9R|WDM|[Technical Brochure Link](/en/service/repair/D9R)|
|Transmission|D9R|WDM|[Technical Brochure Link](/en/service/repair/D9R)|
|Clutch & Brake GP-Steering|D9R|WDM|[Technical Brochure Link](/en/service/repair/D9R)|
|Drive GP-Final|D9R|WDM|[Technical Brochure Link](/en/service/repair/D9R)|
|Engine|D8R|9EM|[Technical Brochure Link](/en/service/repair/D8R)|
|Torque Converter|D8R|9EM|[Technical Brochure Link](/en/service/repair/D8R)|
|Transmission|D8R|9EM|[Technical Brochure Link](/en/service/repair/D8R)|
|Drive GP-Final|D8R|9EM|[Technical Brochure Link](/en/service/repair/D8R)|
|Brake & Differential Drive GP|D8R|9EM|[Technical Brochure Link](/en/service/repair/D8R)|
|Torque Converter|D8R|7XM|[Technical Brochure Link](/en/service/repair/D8R)|
|Transmission|D8R|7XM|[Technical Brochure Link](/en/service/repair/D8R)|
|Engine|D8T|JJ5|[Technical Brochure Link](/en/service/repair/D8T)|
|Torque Converter|D8T|JJ5|[Technical Brochure Link](/en/service/repair/D8T)|
|Transmission|D8T|JJ5|[Technical Brochure Link](/en/service/repair/D8T)|
|Drive GP-Final|D8T|JJ5|[Technical Brochure Link](/en/service/repair/D8T)|
|Brake & Differential Drive GP|D8T|JJ5|[Technical Brochure Link](/en/service/repair/D8T)|
|Engine|992K|H4C - ZMX|[Technical Brochure Link](/en/service/repair/992K)|
|Torque Converter|992K|H4C - ZMX|[Technical Brochure Link](/en/service/repair/992K)|
|Transmission|992K|H4C - ZMX|[Technical Brochure Link](/en/service/repair/992K)|
|Axle GP-Front|992K|H4C - ZMX|[Technical Brochure Link](/en/service/repair/992K)|
|Differential|992K|H4C - ZMX|[Technical Brochure Link](/en/service/repair/992K)|
|Wheel GP-Final Drive & Brake|992K|H4C - ZMX|[Technical Brochure Link](/en/service/repair/992K)|
|Axle GP-Rear|992K|H4C - ZMX|[Technical Brochure Link](/en/service/repair/992K)|
|Axle GP-Front|992K|H4C - ZMX|[Technical Brochure Link](/en/service/repair/992K)|
|Brake GP-Parking|992K|H4C - ZMX|[Technical Brochure Link](/en/service/repair/992K)|
|Engine|988H|BXY|[Technical Brochure Link](/en/service/repair/988H)|
|Torque Converter|988H|BXY|[Technical Brochure Link](/en/service/repair/988H)|
|Transmission|988H|BXY|[Technical Brochure Link](/en/service/repair/988H)|
|Differential|988H|BXY|[Technical Brochure Link](/en/service/repair/988H)|
|Axle GP-Front|988H|BXY|[Technical Brochure Link](/en/service/repair/988H)|
|Wheel GP-Final Drive & Brake|988H|BXY|[Technical Brochure Link](/en/service/repair/988H)|
|Axle GP-Rear|988H|BXY|[Technical Brochure Link](/en/service/repair/988H)|
|Brake GP-Parking|988H|BXY|[Technical Brochure Link](/en/service/repair/988H)|
|Engine|6060|DH3|[Technical Brochure Link](/en/service/repair/6060)|
|Drive GP-Swing|6060|DH3|[Technical Brochure Link](/en/service/repair/6060)|
|Pump Gear Box|6060|DH3|[Technical Brochure Link](/en/service/repair/6060)|
|Engine|6040|DHX|[Technical Brochure Link](/en/service/repair/6040)|
|Drive GP-Swing|6040|DHX|[Technical Brochure Link](/en/service/repair/6040)|
|Pump Gear Box|6040|DHX|[Technical Brochure Link](/en/service/repair/6040)|
|Engine|6030|DHL|[Technical Brochure Link](/en/service/repair/6030)|
|Drive GP-Swing|6030|DHL|[Technical Brochure Link](/en/service/repair/6030)|
|Engine|390D|WAP|[Technical Brochure Link](/en/service/repair/390D)|
|Drive GP-Swing|390D|WAP|[Technical Brochure Link](/en/service/repair/390D)|
|Drive GP-Final|390D|WAP|[Technical Brochure Link](/en/service/repair/390D)|
|Motor & Mtg GP-Swing|390D|WAP|[Technical Brochure Link](/en/service/repair/390D)|
|Cylinder GP-Boom|390D|WAP|[Technical Brochure Link](/en/service/repair/390D)|
|Cylinder GP-Bucket|390D|WAP|[Technical Brochure Link](/en/service/repair/390D)|
|Cylinder GP-Stick|390D|WAP|[Technical Brochure Link](/en/service/repair/390D)|
|Engine|390F|GAY|[Technical Brochure Link](/en/service/repair/390F)|
|Drive GP-Swing|390F|GAY - HJD|[Technical Brochure Link](/en/service/repair/390F)|
|Motor & Mtg GP-Swing|390F|GAY - HJD|[Technical Brochure Link](/en/service/repair/390F)|
|Engine|395|SGD|[Technical Brochure Link](/en/service/repair/395)|
|Drive GP-Swing|395|SGD|[Technical Brochure Link](/en/service/repair/395)|
|Motor & Mtg GP-Swing|395|SGD|[Technical Brochure Link](/en/service/repair/395)|
|Engine|16M|R9H - B9H|[Technical Brochure Link](/en/service/repair/16M)|
|Brake GP-Parking|16M|R9H - B9H|[Technical Brochure Link](/en/service/repair/16M)|
|Transmission|16M|R9H - B9H|[Technical Brochure Link](/en/service/repair/16M)|
|Axle GP-Rear|16M|R9H - B9H|[Technical Brochure Link](/en/service/repair/16M)|
|Differential|16M|R9H - B9H|[Technical Brochure Link](/en/service/repair/16M)|
|Drive GP-Final|16M|R9H - B9H|[Technical Brochure Link](/en/service/repair/793d)|
|Axle GP-Front|16M|R9H - B9H|[Technical Brochure Link](/en/service/repair/16M)|
|Wheel GP-Service Brake|16M|R9H - B9H|[Technical Brochure Link](/en/service/repair/16M)|
|Transmission|16H|6ZJ - ATS|[Technical Brochure Link](/en/service/repair/16H)|
|Wheel GP-Service Brake|16H|6ZJ - ATS|[Technical Brochure Link](/en/service/repair/16H)|
|Differential|16H|6ZJ - ATS|[Technical Brochure Link](/en/service/repair/16H)|
|Drive GP-Final|16H|6ZJ - ATS|[Technical Brochure Link](/en/service/repair/16H)|
|Engine|6015|DHB|[Technical Brochure Link](/en/service/repair/6015)|
|Pump Gear Box|6015|DHB|[Technical Brochure Link](/en/service/repair/6015)|
|Drive GP-Swing|6015|DHB|[Technical Brochure Link](/en/service/repair/6015)|
|Drive GP-Final|6015|DHB|[Technical Brochure Link](/en/service/repair/6015)|
|Engine|6015B|FKD|[Technical Brochure Link](/en/service/repair/6015B)|
|Drive GP-Final|6015B|FKD|[Technical Brochure Link](/en/service/repair/6015B)|
|Drive GP-Swing|6015B|FKD|[Technical Brochure Link](/en/service/repair/6015B)|
|Drive GP-Final|6015B|FKD|[Technical Brochure Link](/en/service/repair/6015B)|
|Pump Gear Box|6015B|FKD|[Technical Brochure Link](/en/service/repair/6015B)|
|Engine|6020B|DNY|[Technical Brochure Link](/en/service/repair/6020B)|
|Drive GP-Final|6020B|D4R|[Technical Brochure Link](/en/service/repair/6020B)|
|Drive GP-Swing|6020B|D4R|[Technical Brochure Link](/en/service/repair/6020B)|
|Pump Gear Box|6020B|D4R|[Technical Brochure Link](/en/service/repair/6020B)|

`,
  },
  {
    id: 6,
    title: "cva",
    handle: "/service/cva",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Service_6_CVA.jpg",
    youtube: "",
    content: `### CVA гэж юу бэ?  

Харилцагч өөрийн Кат® машинд тоноглогдсон хиймэл дагуулын төхөөрөмжийн тусламжтайгаар төлөвлөгөөт хугацааны үйлчилгээгээр дамжуулан техникийн төлөвлөгөөт зөвөлгөөг авах. Катерпилларын оргинал сэлбэгийг цаг алдалгүй хүссэн газартаа хүргүүлэн авах ингэхдээ урьдчилан сэргийлсэн гарын авлагын хамт таны гарт хүргэгдэх болно. Тоног төхөөрөмжийн хамгаалалтын төлөвлөгөө нь төлөвлөөгүй гэнэтийн зардлаас урьдчилан сэргийлүүлэх. Харилцагчийн машин дэх бүхий л зохицуулалт тэр тусмаа насжилт түүний төлөвлөгөөг хамгийн энгийнээр таны гар утасанд мэдээллэнэ. Мөн эдгээр нь та машиндаа сар тутам зарцуулах хөрөнгө оруулалтыг багасгаж өмчлөлийн үеийн зардлыг хамгийн бага хэмжээнд барих үйлчилгээ юм. Энэ бол Катерпилларын Харилцагчийн үнэ цэнийн гэрээ юм.  
  
![CVA](http://d3leeb4r1qy96s.cloudfront.net/assets/img/service/CVA.jpg)`,
    content_en: `### CVA гэж юу бэ?  

Харилцагч өөрийн Кат® машинд тоноглогдсон хиймэл дагуулын төхөөрөмжийн тусламжтайгаар төлөвлөгөөт хугацааны үйлчилгээгээр дамжуулан техникийн төлөвлөгөөт зөвөлгөөг авах. Катерпилларын оргинал сэлбэгийг цаг алдалгүй хүссэн газартаа хүргүүлэн авах ингэхдээ урьдчилан сэргийлсэн гарын авлагын хамт таны гарт хүргэгдэх болно. Тоног төхөөрөмжийн хамгаалалтын төлөвлөгөө нь төлөвлөөгүй гэнэтийн зардлаас урьдчилан сэргийлүүлэх. Харилцагчийн машин дэх бүхий л зохицуулалт тэр тусмаа насжилт түүний төлөвлөгөөг хамгийн энгийнээр таны гар утасанд мэдээллэнэ. Мөн эдгээр нь та машиндаа сар тутам зарцуулах хөрөнгө оруулалтыг багасгаж өмчлөлийн үеийн зардлыг хамгийн бага хэмжээнд барих үйлчилгээ юм. Энэ бол Катерпилларын Харилцагчийн үнэ цэнийн гэрээ юм.  
  
![CVA](http://d3leeb4r1qy96s.cloudfront.net/assets/img/service/CVA.jpg)`,
  },
];
